/* eslint-disable import/no-anonymous-default-export */
export default {
  changeTimezone: "Change timezone",
  save: "Save",
  cancel: "Cancel",
  timeZoneLabel: "Select time zone",
  timeZoneError: "Please select timezone",
};
